import { useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
import querystring from 'querystring';
import env from '../config/environment';
import { URL_AUTH_TOKEN } from '../config/endpoints';
import { AppContext } from '../context';

const useAuthToken = () => {
  const [token, setToken] = useState(sessionStorage.getItem('oauth_token'));
  const [error, setError] = useState(null);
  const { ibcLogged } = useContext(AppContext);
  const refreshToken = useCallback(async () => {
    if (ibcLogged === undefined) {
      return '';
    }
    const tokenRequestBody = {
      grant_type: 'client_credentials',
      scope: env.SCOPE,
      client_id: ibcLogged ? env.CLIENT_ID_IBC : env.CLIENT_ID,
      client_secret: ibcLogged ? env.CLIENT_SECRET_IBC : env.CLIENT_SECRET,
    };
    try {
      const { data } = await axios.post(
        URL_AUTH_TOKEN(),
        querystring.stringify(tokenRequestBody),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        }
      );
      setToken(data.access_token);
      return data.access_token;
    } catch (err) {
      setError(err);
    }
    return '';
  }, [ibcLogged]);
  useEffect(() => {
    if (token) {
      sessionStorage.setItem('oauth_token', token);
    } else {
      refreshToken();
    }
  }, [token, refreshToken]);
  return { error, refreshToken, token };
};
export default useAuthToken;
